import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import withAuth from './withAuth';
import withAdminAuth from './withAdminAuth';

import SignUp from './containers/SignUp';
import SignIn from './containers/SignIn';
import { SignOut } from './containers/SignOut';

import { RedirectOk } from './containers/RedirectOk';
import { RedirectNg } from './containers/RedirectNg';

import SetupPlan from './containers/SetupPlan';
import SetupEnterprisePlan from './containers/SetupEnterprisePlan';
import SetupPayment from './containers/SetupPayment';
import SetupFinish from './containers/SetupFinish';

import Dashboard from './containers/Dashboard';
import ChangePlan from './containers/ChangePlan';
import ChangePayment from './containers/ChangePayment';
import ChangeFinish from './containers/ChangeFinish';
import Billing from './containers/Billing';
import Account from './containers/Account';

import { AdminDashboard } from './containers/AdminDashboard';
import GA from './utils/GoogleAnalytics';

function AppRouter() {
  return (
    <Router>
      {GA.init()}

      <Route exact path="/sign-up" component={GA.withTracker(SignUp)} />
      <Route exact path="/sign-in" component={GA.withTracker(SignIn)} />
      <Route exact path="/sign-out" component={GA.withTracker(withAuth(SignOut))} />
      <Route exact path="/redirect-ok" component={GA.withTracker(RedirectOk)} />
      <Route exact path="/redirect-ng" component={GA.withTracker(RedirectNg)} />
      <Route exact path="/dashboard" component={GA.withTracker(withAuth(Dashboard))} />
      <Route exact path="/change-payment" component={GA.withTracker(withAuth(ChangePayment))} />
      <Route exact path="/change-finish" component={GA.withTracker(withAuth(ChangeFinish))} />
      <Route exact path="/setup-finish" component={GA.withTracker(withAuth(SetupFinish))} />
      <Route exact path="/setup-payment" component={GA.withTracker(withAuth(SetupPayment))} />
      <Route exact path="/setup-plan" component={GA.withTracker(withAuth(SetupPlan))} />
      <Route exact path="/change-plan" component={GA.withTracker(withAuth(ChangePlan))} />
      <Route exact path="/account" component={GA.withTracker(withAuth(Account))} />
      <Route exact path="/billing-history" component={GA.withTracker(withAuth(Billing))} />
      <Route exact path="/setup-enterprise-plan" component={GA.withTracker(withAuth(SetupEnterprisePlan))} />

      <Route exact path="/change-payment-test" component={GA.withTracker(ChangePayment)} />
      <Route exact path="/change-finish-test" component={GA.withTracker(ChangeFinish)} />
      <Route exact path="/setup-finish-test" component={GA.withTracker(SetupFinish)} />
      <Route exact path="/setup-payment-test" component={GA.withTracker(SetupPayment)} />
      <Route exact path="/dashboard-test" component={GA.withTracker(Dashboard)} />
      <Route exact path="/setup-plan-test" component={GA.withTracker(SetupPlan)} />
      <Route exact path="/change-plan-test" component={GA.withTracker(ChangePlan)} />
      <Route exact path="/account-test" component={GA.withTracker(Account)} />
      <Route exact path="/setup-enterprise-plan-test" component={GA.withTracker(SetupEnterprisePlan)} />

      <Route exact path="/admin-dashboard" component={GA.withTracker(withAdminAuth(AdminDashboard))} />
      <Route exact path="/admin-dashboard-test" component={GA.withTracker(AdminDashboard)} />
      <Route exact path="/billing-history-test" component={GA.withTracker(Billing)} />

    </Router>
  );


}

export default AppRouter;
